export enum AuthSteps {
    AUTO_LOGIN_DOMAIN_STEP = 1,
    LOGIN_PASSWORD_STEP = 2,
    FORBIDDEN_STEP = 403,
    ERROR_STEP = 500
}